import { StringMap } from "i18next";
import { useCallback } from "react";
import { useTranslation as useI18NextTranslation } from "react-i18next";

export function useTranslation() {
  const { t } = useI18NextTranslation();

  const translate = useCallback(
    (key: string, placeHolderDict?: StringMap) => {
      return t(key, placeHolderDict ?? {});
    },
    [t]
  );

  return { translate };
}
